import type { ReactNode } from 'react';
import { CRITERION_MARK_LABELS, CRITERION_MARK_SYMBOLS, type CriterionMark } from '@nest-recruit/shared';
import styles from './ranking.module.css';

/**
 * One criterion's ✓ ◐ ✗ ? (§L30), coloured by meaning and never by colour alone: the glyph
 * and its name say it too. A mark a person set is underlined (design card "Ranking"). On RNK-01's
 * grid it sits on a tinted tile (ADR 0049, as in the mockup); elsewhere it is the bare glyph.
 */
export function MarkGlyph({
  mark,
  isCorrected = false,
  label,
  isTile = false,
}: {
  readonly mark: CriterionMark;
  readonly isCorrected?: boolean;
  readonly label?: string;
  readonly isTile?: boolean;
}): ReactNode {
  const name = `${label ? `${label}: ` : ''}${CRITERION_MARK_LABELS[mark]}${isCorrected ? ', set by a person' : ''}`;
  return (
    <span className={isTile ? styles.markTile : styles.mark} data-mark={mark} data-corrected={isCorrected || undefined} role="img" aria-label={name} title={name}>
      {CRITERION_MARK_SYMBOLS[mark]}
    </span>
  );
}
